import { useSelector } from "react-redux";
import { appdataSelector } from "reducers/appdata/appdata";
import { vendordataSelector } from "reducers/vendordata/vendordata";

function Header() {
  const vendordata = useSelector(vendordataSelector);
  const appdata = useSelector(appdataSelector);

  
  const req_types = {
    NV: "New Vendor",
    CV: "Change Vendor",
    EVT: "Extend Vendor",
    EVI: "Extend Intercompany Vendor",
    RV: "Reactivate Vendor"
  };

  const masterdata = vendordata.activeVendor.master;

  const headerparts = {
    "Request Type": req_types[masterdata.REQ_TYP],
    Requester: masterdata.REQ_USR_NAME
  };

  if (masterdata.REQ_TYP == "EVI" || masterdata.REQ_TYP == "EVT") {
    let company_from_body = "";
    let company_new_body = "";
    let po_from_body = "";
    let po_new_body = "";
    appdata.listvalues.companyDropdownValues.map((item, key) => {
      if (item["BUKRS"] == masterdata.BUKRS) {
        company_from_body = item["BUTXT"];
      }

      if (item["BUKRS"] == masterdata.BUKRS_NEW) {
        company_new_body = item["BUTXT"];
      }
    });

    appdata.listvalues.purchasingOrganisations.map((item, key) => {
      if (item["EKORG"] == masterdata.EKORG) {
        po_from_body = item["EKOTX"];
      }

      if (item["EKORG"] == masterdata.EKORG_NEW) {
        po_new_body = item["EKOTX"];
      }
    });

    /*
  
    let company_account_body = "";
    props.listvalues.companyAccountCodes.map((item, key) => {
      if (item["KTOKK"] == props.vendor.DESCRIPTION.KTOKK) {
        company_account_body = item["TXT30"];
      }
    });
  
    let vendor_type_body = "";
    props.listvalues.requestTypeDropdownValues.map((item, key) => {
      if (item["VALUE"] == props.vendor.DESCRIPTION.REQ_TYP) {
        vendor_type_body = item["DESCRIPTION"];
      }
    }); */

    Object.assign(headerparts, {
      "Extend From Company": masterdata.BUKRS + " - " + company_from_body
    });
    Object.assign(headerparts, {
      "Extend To Company": masterdata.BUKRS_NEW + " - " + company_new_body
    });
    Object.assign(headerparts, {
      "Emp. Vendor ID": masterdata.EMP_LIFNR
    });
    Object.assign(headerparts, {
      "Vendor ID": masterdata.LIFNR + " - " + masterdata.LIFNR_BODY
    });
    Object.assign(headerparts, {
      "NEW Vendor ID": masterdata.LIFNR_NEW
    });
    Object.assign(headerparts, {
      "Extend from Purchasing Organisation":
        masterdata.EKORG + " - " + po_from_body
    });
    Object.assign(headerparts, {
      "Extend to Purchasing Organisation":
        masterdata.EKORG_NEW + " - " + po_new_body
    });
  } else {
    let company_code = "";
    let company_body = "";
    appdata.listvalues.companyDropdownValues.map((item, key) => {
      if (item["BUKRS"] == masterdata.BUKRS) {
        company_code = item["BUKRS"];
        company_body = item["BUTXT"];
      }
    });

    let purch_org_code = "";
    let purch_org_body = "";
    appdata.listvalues.purchasingOrganisations.map((item, key) => {
      if (item["EKORG"] == masterdata.EKORG) {
        purch_org_code = item["EKORG"];
        purch_org_body = item["EKOTX"];
      }
    });

    let acc_code = "";
    let acc_body = "";
    appdata.listvalues.companyAccountCodes.map((item, key) => {
      if (item["KTOKK"] == masterdata.KTOKK) {
        acc_code = item["KTOKK"];
        acc_body = item["TXT30"];
      }
    });

    Object.assign(headerparts, { "Vendor Type": masterdata.VEND_TYP });
    Object.assign(headerparts, {
      "Company Code": company_code + " - " + company_body
    });
    Object.assign(headerparts, {
      "Purchasing Organisation": purch_org_code + " - " + purch_org_body
    });
    Object.assign(headerparts, { Account: acc_code + " - " + acc_body });
    Object.assign(headerparts, { "Emp. Vendor ID": masterdata.EMP_LIFNR });
    Object.assign(headerparts, { "Vendor ID": masterdata.LIFNR });
  }

  console.log(headerparts);
  return (
    <div className="mt-2">
      {Object.keys(headerparts).map(key => {
        return (
          <div className="row" key={"headerrow" + key}>
            <div className="col-3" key={"headerleft" + key}>
              <b>{key}:</b>
            </div>
            <div className="col" key={"headerright" + key}>
              {headerparts[key]}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Header;
